import { integersFormatter, secondsToHHmmss } from '@carboncopyco/utils';
import { StatsCard } from '../../StatsCard';
import { useGetTotalsData } from '../../hooks';

export const TotalPresentations = () => {
  const {
    data,
    isLoading,
    isLoadingPrevData,
    getPercentages,
    getDescription,
    chartData,
    isError,
  } = useGetTotalsData({
    resourceTypes: ['managed_presentation', 'play'],
    assetType: 'demo',
  });

  const { values } = data ?? {};

  return (
    <StatsCard
      isError={isError}
      isEmpty={!isLoading && !values?.occurrences}
      title="Demos given"
    >
      <StatsCard.Graph
        title="Demos given"
        kpiNumber={
          values?.occurrences ? integersFormatter(values.occurrences) : ''
        }
        kpiRawNumber={values?.occurrences}
        kpiPercentage={getPercentages('occurrences')}
        description={getDescription('occurrences')}
        lineChartData={chartData}
        loading={isLoading || isLoadingPrevData}
        negative={getPercentages('occurrences') < 0}
      />
      <StatsCard.Item
        title="Median duration"
        value={
          values?.medianDuration ? secondsToHHmmss(values.medianDuration) : ''
        }
        loading={isLoading}
        percentage={getPercentages('medianDuration')}
        negative={getPercentages('medianDuration') < 0}
        description={getDescription('medianDuration')}
      />
      <StatsCard.Item
        title="Avg. screens presented"
        value={
          values?.avgScreensVisited
            ? integersFormatter(values.avgScreensVisited)
            : ''
        }
        loading={isLoading || isLoadingPrevData}
      />
    </StatsCard>
  );
};
